/**
 * Composable for tracking and managing the latest selected brand in search
 *
 * @returns {Object} Brand selection management methods
 * @property {Ref<string>} latestSelectedBrand - The most recently selected brand
 * @property {Function} updateLatestSelectedBrand - Method to update the latest selected brand
 */
export const useSearchLatestBrandSelection = () => {
  /**
   * Reactive reference to the latest selected brand using Google Analytics entity
   * @type {Ref<string>}
   */
  const latestSelectedBrand = useGAEntity<string>('GA_SEARCH_BRAND_SELECTED')

  /**
   * Update the latest selected brand
   *
   * @param {string} brand - The brand to set as the latest selection
   */
  const updateLatestSelectedBrand = (brand: string) => {
    latestSelectedBrand.value = brand
  }

  return {
    latestSelectedBrand,
    updateLatestSelectedBrand,
  }
}
